import React from "react";
import { SignIn as _SignIn } from "../components/sign-in";
const SignIn = () => {
  return <_SignIn />;
};

export default SignIn;
